import { useContext } from 'react';
import { TenantContext } from '../contexts/TenantContext';

const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) throw new Error('TenantContext must be placed within TenantProvider');
  return context;
};

export default useTenant;
